import * as React from "react";

const ICON_PATHS: Record<string, string> = {
  search:    "M11 19a8 8 0 1 1 5.293-14.001M21 21l-4.35-4.35",
  filter:    "M4 5h16M7 12h10M10 19h4",
  columns:   "M4 4h16v16H4z M10 4v16 M16 4v16",
  download:  "M12 3v12 M7 10l5 5 5-5 M5 21h14",
  upload:    "M12 21V9 M7 14l5-5 5 5 M5 3h14",
  plus:      "M12 5v14 M5 12h14",
  minus:     "M5 12h14",
  x:         "M6 6l12 12 M18 6L6 18",
  check:     "M5 12l4 4L19 7",
  chevDown:  "M6 9l6 6 6-6",
  chevRight: "M9 6l6 6-6 6",
  chevUp:    "M6 15l6-6 6 6",
  chevLeft:  "M15 6l-6 6 6 6",
  more:      "M5 12h.01 M12 12h.01 M19 12h.01",
  menu:      "M4 6h16M4 12h16M4 18h16",
  user:      "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21a8 8 0 0 1 16 0",
  users:     "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M2 21a7 7 0 0 1 14 0 M16 3.5a4 4 0 0 1 0 7.5 M22 21a7 7 0 0 0-5-6.7",
  mail:      "M3 6h18v12H3z M3 6l9 7 9-7",
  phone:     "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
  building:  "M3 21h18 M5 21V7l8-4v18 M19 21V11l-6-3 M9 9v.01 M9 13v.01 M9 17v.01",
  calendar:  "M3 6h18v15H3z M16 3v6 M8 3v6 M3 11h18",
  chart:     "M3 21h18 M7 17V10 M12 17V5 M17 17v-7",
  pie:       "M21 12a9 9 0 1 1-9-9v9h9z",
  line:      "M3 17l6-6 4 4 8-8",
  table:     "M3 5h18v14H3z M3 10h18 M3 15h18 M9 5v14",
  dashboard: "M3 13h8V3H3z M13 21h8V11h-8z M13 9h8V3h-8z M3 21h8v-6H3z",
  star:      "M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14 2 9.27l6.91-1.01L12 2z",
  heart:     "M12 21s-7-4.5-7-10a4 4 0 0 1 7-2.65A4 4 0 0 1 19 11c0 5.5-7 10-7 10z",
  alert:     "M12 9v4 M12 17h.01 M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z",
  info:      "M12 16v-4 M12 8h.01 M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
  settings:  "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z",
  logout:    "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4 M16 17l5-5-5-5 M21 12H9",
  external:  "M14 3h7v7 M10 14L21 3 M21 14v7H3V3h7",
  tag:       "M20.59 13.41L13 21l-8-8V5h8z M7 7h.01",
  bookmark:  "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z",
  eye:       "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  eyeOff:    "M9.88 9.88a3 3 0 0 0 4.24 4.24 M10.73 5.08A11 11 0 0 1 12 5c7 0 11 7 11 7a13.16 13.16 0 0 1-1.67 2.68 M6.61 6.61A13.5 13.5 0 0 0 1 12s4 7 11 7a9.74 9.74 0 0 0 5.39-1.61 M2 2l20 20",
  drag:      "M9 5h.01 M9 12h.01 M9 19h.01 M15 5h.01 M15 12h.01 M15 19h.01",
  refresh:   "M23 4v6h-6 M1 20v-6h6 M3.51 9a9 9 0 0 1 14.85-3.36L23 10 M1 14l4.64 4.36A9 9 0 0 0 20.49 15",
  arrowDown: "M12 5v14 M5 12l7 7 7-7",
  arrowUp:   "M12 19V5 M5 12l7-7 7 7",
  shield:    "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  key:       "M21 2l-9.6 9.6 M15.5 7.5l3 3 M11.4 11.4a5 5 0 1 1-7.07 7.07 5 5 0 0 1 7.07-7.07z",
  sparkles:  "M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5z M19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8z M5 14l.6 1.6L7 16l-1.4.4L5 18l-.6-1.6L3 16l1.4-.4z",
  trash:     "M3 6h18 M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2 M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6",
  edit:      "M12 20h9 M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z",
};

export type IconName = keyof typeof ICON_PATHS;

export function Icon({
  name,
  size = 16,
  stroke = 1.75,
  className = "",
  style = {},
}: {
  name: string;
  size?: number;
  stroke?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const d = ICON_PATHS[name];
  if (!d) return null;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, ...style }}
      aria-hidden="true"
    >
      {d.split(" M").map((p, i) => (
        <path key={i} d={(i === 0 ? "" : "M") + p} />
      ))}
    </svg>
  );
}

export function TidyMark({ size = 28, color = "var(--brand-500)" }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <rect x="2" y="2" width="28" height="28" rx="9" fill={color} />
      <path d="M9 12h14" stroke="white" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M16 12v11" stroke="white" strokeWidth="2.4" strokeLinecap="round" />
      <circle cx="22.5" cy="20" r="2.2" fill="#ffd96b" />
    </svg>
  );
}

export function BrandMark({ size = 22 }: { size?: number }) {
  return (
    <span
      className="brand-mark"
      style={{ display: "inline-flex", alignItems: "center", gap: 8, fontWeight: 800, letterSpacing: "-0.02em", color: "var(--ink-900)" }}
    >
      <span
        className="dot"
        style={{
          width: size,
          height: size,
          borderRadius: 7,
          background: "var(--brand-500)",
          position: "relative",
          display: "inline-block",
        }}
      >
        <span
          style={{
            content: "''",
            position: "absolute",
            right: -2,
            top: -2,
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: "#ffd96b",
            display: "block",
          }}
        />
      </span>
      Tidy<b style={{ color: "var(--brand-600)", fontWeight: 800 }}>View</b>
    </span>
  );
}
